import React from "react";
import Body from "../layouts/Body";
import MUIDataTable from "mui-datatables";
import {
  IconButton,
  TableCell,
  TableFooter,
  TableRow,
  Typography,
} from "@mui/material";
import { useMenteeContext } from "../context/MenteeContext";
import { Loading } from "../components";
import { Cached } from "@mui/icons-material";

const Dashboard = () => {
  const { scoreData, quarter, loading, updateDashboardData } =
    useMenteeContext();

  let CustomBody = ({ value, programId }) => {
    return (
      <>
        <div>LPC: {Number(value?.learningProcessCompliance).toFixed(2)}</div>
        <div>TE: {Number(value?.teachingEffectiveness).toFixed(2)}</div>
        <div>LE: {Number(value?.learningEffectiveness).toFixed(2)}</div>
        {programId == 13 && (
          <div>FA: {Number(value?.facilitatorsAttributes).toFixed(2)}</div>
        )}
        {programId == 6 && (
          <div>CLA: {Number(value?.changeLeadersAttributes).toFixed(2)}</div>
        )}
        {/* adding new program for EDP  */}
        {programId == 9 && (
          <div>FA: {Number(value?.facilitatorsAttributes).toFixed(2)}</div>
        )}
        <div
          style={{
            color: Number(value?.quaterScore) == 0 ? "red" : "green",
            fontWeight: 600,
          }}
        >
          Overall: {Number(value?.quaterScore).toFixed(2)}
        </div>
      </>
    );
  };

  const columns = [
    {
      name: "name",
      label: "Name",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "programId",
      options: {
        filter: false,
        sort: false,
        display: false,
        download: false,
      },
    },
    {
      name: "primaryDomain",
      label: "Primary Domain Type",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "specialization",
      label: "YDM or Domain Specialization",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "programName",
      label: "Program Name",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "currentQuarter",
      label: quarter?.currentQuarter,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta) => (
          <CustomBody value={value} programId={tableMeta.rowData[1]} />
        ),
      },
    },
    {
      name: "firstPreviousQuarter",
      label: quarter?.firstPreviousQuarter,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta) => (
          <CustomBody value={value} programId={tableMeta.rowData[1]} />
        ),
      },
    },
    // {
    //   name: "secondPreviousQuater",
    //   label: quarter?.secondPreviousQuater,
    //   options: {
    //     filter: true,
    //     sort: true,
    //     customBodyRender: (value, tableMeta) => (
    //       <CustomBody value={value} programId={tableMeta.rowData[1]} />
    //     ),
    //   },
    // },
    // {
    //   name: "thirdPreviousQuarter",
    //   label: quarter?.thirdPreviousQuarter,
    //   options: {
    //     filter: true,
    //     sort: true,
    //     customBodyRender: (value, tableMeta) => (
    //       <CustomBody value={value} programId={tableMeta.rowData[1]} />
    //     ),
    //   },
    // },
    // {
    //   name: "fourthPreviousQuater",
    //   label: quarter?.fourthPreviousQuater,
    //   options: {
    //     filter: true,
    //     sort: true,
    //     customBodyRender: (value, tableMeta) => (
    //       <CustomBody value={value} programId={tableMeta.rowData[1]} />
    //     ),
    //   },
    // },
  ];

  return (
    <>
      <Body>
        <Typography
          variant="h5"
          className="page-title text-centered"
          color="primary"
        >
          Dashboard
        </Typography>
        <MUIDataTable
          columns={columns}
          data={scoreData}
          title="Facilitators Score (Quarterly Overall Rating)"
          options={{
            selectableRows: "none", // <===== will turn off checkboxes in rows
            print: false,
            viewColumns: false,
            customToolbar: function () {
              return (
                <IconButton onClick={updateDashboardData}>
                  <Cached />
                </IconButton>
              );
            },
            customTableBodyFooterRender: function (opts) {
              return (
                <TableFooter>
                  <TableRow>
                    <TableCell
                      colSpan={7}
                      sx={{ fontWeight: 600, color: "black" }}
                    >
                      LPE : Learning Process Compliance, TE : Teaching
                      Effectiveness, LE : Learning Effectiveness, FA :
                      Facilitators Attributes, CLA : Change Leaders Attributes
                    </TableCell>
                  </TableRow>
                </TableFooter>
              );
            },
          }}
        />
        <Loading open={loading} />
      </Body>
    </>
  );
};

export default Dashboard;
